export default (Tc: number, RH: number): number => {
  const b = 17.625;
  const c = 243.04;

  const gammaTR = Math.log(RH / 100) + (b * Tc) / (c + Tc);

  return (c * gammaTR) / (b - gammaTR);
};
